import { api } from '@/internationalization/api-client'
import { qk } from '@/internationalization/query-keys'
import { useQuery } from '@tanstack/react-query'
import type { SharedSummary } from '@/types'

/**
 * The public share endpoint.
 *
 * It is addressed by TOKEN, not by meeting id, and it returns a `SharedSummary`
 * rather than a `MeetingDetail` - no transcript, no audio, no participant
 * emails. Making the projection its own shape means the minimum-disclosure rule
 * is enforced by the type, not by a caller remembering it.
 *
 * No tenant header is sent: the token carries its own scope.
 */
export const shareApi = {
  get: (token: string) => api.get<SharedSummary>(`/share/${token}`),
}

export function useSharedSummary(token: string | undefined) {
  return useQuery({
    queryKey: qk.share(token ?? ''),
    queryFn: () => shareApi.get(token as string),
    enabled: Boolean(token),
    retry: false,
  })
}
